import React from 'react';

import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

import { METRICS, METRIC_TABS, type MetricId, type MetricView } from './metrics';

type Props = { view: MetricView; value: MetricId; onChange: (metric: MetricId) => void };

/** The workbook's "Metrics Filter": switches the measure a tab’s matrix shows. */
export default function MetricSelect({ view, value, onChange }: Props) {
  const id = `daily-board-${view}-metric`;
  return (
    <FormControl size="small" sx={{ minWidth: 220, alignSelf: 'flex-start' }}>
      <InputLabel id={id}>Metric</InputLabel>
      <Select
        labelId={id}
        label="Metric"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-describedby={`${id}-help`}
      >
        {METRIC_TABS[view].options.map((option) => (
          <MenuItem key={option.metric} value={option.metric}>
            {METRICS[option.metric].label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText id={`${id}-help`} sx={{ mx: 0 }}>
        Select a metric
      </FormHelperText>
    </FormControl>
  );
}
